/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PositionV2Dto } from './positionV2Dto';
import { MachineSettingsDto } from './machineSettingsDto';
import { ExaAdapterIdDto } from './exaAdapterIdDto';
import { EnterpriseIdDto } from './enterpriseIdDto';

export interface MachineV2Dto {
  active?: boolean;
  color?: string;
  cost?: number;
  costPer?: string;
  deleted?: boolean;
  externalId?: string;
  foxId?: string;
  gpsToHitchDistance?: number;
  id?: number;
  lastPosition?: PositionV2Dto;
  machineSettings?: MachineSettingsDto;
  make?: string;
  mileage?: number;
  model?: string;
  name?: string;
  operatingHours?: number;
  owner?: EnterpriseIdDto;
  pairedAdapter?: ExaAdapterIdDto;
  type?: string;
  updated?: string;
  xtrCanValuesConfig?: string;
  year?: number;
}
